import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import React from 'react';

import Mobile from './mobile';
import TabletDesktop from './tablet-desktop';
import { buildCheckboxConfig, buildFilterConfig } from './utils';
import { type Dispatch } from '@/app-state/store';
import { type FiltersState } from '@/app-state/models/filters/state';

type DiscoveryFilterProps = {
  filterActions: Dispatch['filters'];
  filterState: FiltersState;
  makes: { label?: string; id?: string }[];
  safetyFeatures: { label?: string; id?: string }[];
};

const DiscoveryFilter = ({ filterActions, filterState, makes, safetyFeatures }: DiscoveryFilterProps) => {
  const { uiSelectedPriceRange } = filterState;
  const { resetSelectedPriceRange, reset } = filterActions;

  const [currentlyOpenFilter, setCurrentlyOpenFilter] = React.useState();

  const checkboxConfig = buildCheckboxConfig(makes, safetyFeatures);
  const filterConfig = buildFilterConfig(checkboxConfig, filterActions, filterState);

  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'fieldId' implicitly has an 'any' type.
  const toggleCurrentlyOpenFilter = (fieldId) =>
    // @ts-expect-error [🤖 PLEASE FIX 🤖]: Expected 1 arguments, but got 0.
    currentlyOpenFilter === fieldId ? setCurrentlyOpenFilter() : setCurrentlyOpenFilter(fieldId);

  const isMobile = useMediaQuery(useTheme().breakpoints.down('lg'));
  const propsForChild = {
    uiSelectedPriceRange,
    reset,
    resetSelectedPriceRange,
    checkboxConfig,
    filterConfig,
    currentlyOpenFilter,
    safetyFeatures,
    toggleCurrentlyOpenFilter,
    filterState,
  };

  return isMobile ? <Mobile {...propsForChild} /> : <TabletDesktop {...propsForChild} />;
};

export default DiscoveryFilter;
